import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../../components/Inputs/ResourceSelect";
import Select from "../../../../../../components/Inputs/Select";
import { useCustomFields } from "../../../../../Settings/CustomFields/context";
import {
    getSettingsResourceSearchFilters,
    renderSettingsResourceLabel
} from "../../../../../../utils/helpers/settings";

export const usePeopleCustomFieldsFilter = () => {
    const { t } = useTranslation();
    const { peopleCustomFields } = useCustomFields();

    return useMemo(() => {
        return [
            {

                name: "custom-field",
                label: t("home-custom-fields"),
                type: "resource-select",
                component: (
                    <ResourceSelect
                        resourcePath="/custom-field/people"
                        mode="multiple"
                        renderLabel={renderSettingsResourceLabel}
                        getSearchFilters={getSettingsResourceSearchFilters}
                        hasSearch
                    />
                ),
            },
            {
                name: "home-custom-fields",
                children: (peopleCustomFields || []).map((customField) => {
                    return {
                        name: customField.code,
                        label: customField.code,
                        type: customField.type === "select" ? "select" : "text",
                        component: customField.type === "select" ? (
                            <Select mode="multiple">
                                {customField.options.map((option) => (
                                    <Select.Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        ) : undefined,
                    };
                }),
            },
        ]
    }, [peopleCustomFields, t]);
}